import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetActiontypeByNameQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type GetActiontypeByNameQuery = { __typename?: 'query_root', actiontypes: Array<{ __typename?: 'actiontypes', id: number, name: string }> };


export const GetActiontypeByNameDocument = gql`
    query GetActiontypeByName($name: String!) {
  actiontypes(where: {name: {_eq: $name}}, limit: 1) {
    id
    name
  }
}
    `;

/**
 * __useGetActiontypeByNameQuery__
 *
 * To run a query within a React component, call `useGetActiontypeByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiontypeByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiontypeByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetActiontypeByNameQuery(baseOptions: Apollo.QueryHookOptions<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables> & ({ variables: GetActiontypeByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>(GetActiontypeByNameDocument, options);
      }
export function useGetActiontypeByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>(GetActiontypeByNameDocument, options);
        }
// @ts-ignore
export function useGetActiontypeByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>;
export function useGetActiontypeByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiontypeByNameQuery | undefined, GetActiontypeByNameQueryVariables>;
export function useGetActiontypeByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>(GetActiontypeByNameDocument, options);
        }
export type GetActiontypeByNameQueryHookResult = ReturnType<typeof useGetActiontypeByNameQuery>;
export type GetActiontypeByNameLazyQueryHookResult = ReturnType<typeof useGetActiontypeByNameLazyQuery>;
export type GetActiontypeByNameSuspenseQueryHookResult = ReturnType<typeof useGetActiontypeByNameSuspenseQuery>;
export type GetActiontypeByNameQueryResult = Apollo.QueryResult<GetActiontypeByNameQuery, GetActiontypeByNameQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/auth/queries/getActiontypeByName.query.gql}
 */
export async function getActiontypeByName(
  variables: GetActiontypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetActiontypeByNameQuery['actiontypes']>
export async function getActiontypeByName(
  variables: GetActiontypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetActiontypeByNameQuery>
export async function getActiontypeByName(
  variables: GetActiontypeByNameQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetActiontypeByNameQuery['actiontypes'] | GetActiontypeByNameQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetActiontypeByNameQuery>(
    GetActiontypeByNameDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.actiontypes
}